import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import productBadgeMessages from 'i18n/productBadgeMessages'
import BodyText from 'LuxKit/Typography/BodyText'
import Label from 'LuxKit/Label/Label'
import Caption from 'LuxKit/Typography/Caption'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

interface Props {
  saleOnDepartures?: boolean
}

export default function TourDiscountLabel(props: Props) {
  const { saleOnDepartures = false } = props
  const intl = useIntl()

  return (
    <Label kind="plain" variant="urgency" startIcon={<SolidFireIcon />}>
      <Caption variant="medium" weight="bold">
        {saleOnDepartures && <FormattedMessage
          id="xPLC1Df4MsKSXvXv5Ak6"
          defaultMessage="Limited Time Special <departures>(select departures)</departures>"
          description="Label indicating a limited-time special discount on select tour departures"
          values={{ departures: (chunks: React.ReactNode) => <BodyText variant="small" as="span" colour="neutral-three">{chunks}</BodyText> }}
        />}
        {!saleOnDepartures && intl.formatMessage(productBadgeMessages.limitedTimeSpecial)}
      </Caption>
    </Label>
  )
}
